const doc = [({"da":({"js":({"admin":({"show_boxes":({"partial":({"box":({"add_new_attribute":"Tilføj ny attribut"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;